// Login.js

import React from 'react';


const NoChatMessage = ({title, msg}) => {

    return (
        <div className="container mx-auto p-4">
            <div className="bg-white border rounded-lg p-6 shadow-md">
                <p className="text-gray-600 text-lg">{title || 'No chat selected' }</p>
                <p className="text-gray-400 mt-2">{msg || 'Please select a chat to start messaging.'}</p>
            </div>
        </div>
    );
};

export default NoChatMessage;